import Component from './Tos'

export default Component
